var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteTextSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "receipt-text-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M64.1666 17.9999V25.0583C64.1666 29.6666 61.25 32.5833 56.6416 32.5833H46.6666V12.1958C46.6666 8.95825 49.3208 6.33325 52.5583 6.33325C55.7375 6.36242 58.6541 7.64575 60.7541 9.74575C62.8541 11.8749 64.1666 14.7916 64.1666 17.9999Z",
    stroke: "#292D32",
    strokeOpacity: 0.4,
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.83337 20.9166V61.7499C5.83337 64.1707 8.57498 65.5416 10.5 64.0832L15.4875 60.3499C16.6542 59.4749 18.2875 59.5916 19.3375 60.6416L24.1791 65.5124C25.3166 66.6499 27.1834 66.6499 28.3209 65.5124L33.2209 60.6124C34.2417 59.5916 35.875 59.4749 37.0125 60.3499L42 64.0832C43.925 65.5124 46.6667 64.1416 46.6667 61.7499V12.1666C46.6667 8.95825 49.2917 6.33325 52.5 6.33325H20.4167H17.5C8.75004 6.33325 5.83337 11.5541 5.83337 17.9999V20.9166Z",
    stroke: "#292D32",
    strokeOpacity: 0.4,
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.4,
    d: "M17.5 26.75H35",
    stroke: "#292D32",
    strokeOpacity: 0.4,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.4,
    d: "M19.6875 38.4165H32.8125",
    stroke: "#292D32",
    strokeOpacity: 0.4,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteTextSvgrepoCom1);
export default __webpack_public_path__ + "static/media/QUOTE-text-svgrepo-com 1.08e45423b6f0fc82cc6d1b1b8da4ef35.svg";
export { ForwardRef as ReactComponent };